import * as React from 'react';

export const StatusNodeDot: React.FC<{
    statusColor: string;
    halfFilled?: boolean;
    innerFilled?: boolean;
    outerBorderColor?: string;
    size?: number;
    outerBorderWidth?: number;
}> = ({ statusColor, halfFilled, innerFilled, outerBorderColor, size = 16, outerBorderWidth = 2 }) => {
    let background;

    if (halfFilled) {
        background = `linear-gradient(90deg, ${statusColor} 0 50%, white 50% 100%)`;
    } else if (innerFilled) {
        background = `radial-gradient(circle, ${statusColor} 0 40%, white 40% 100%)`;
    } else {
        background = statusColor;
    }

    return (
        <div
            style={{
                borderColor: outerBorderColor ?? '#666464',
                borderWidth: outerBorderWidth,
                borderStyle: 'solid',
                width: size,
                height: size,
                borderRadius: '50%',
                background,
            }}
        />
    );
};

interface StatusNodeProps {
    statusColor: string;
    showHead?: boolean;
    showTail?: boolean;
    hideConnector?: boolean;
    halfFilled?: boolean;
    innerFilled?: boolean;
    outerBorderColor?: string;
    shouldShowMiniVersion?: boolean;
}

export const StatusNode = (props: StatusNodeProps) => {
    const showTail = props.showTail ?? true;
    const showHead = props.showHead ?? true;
    const hideConnector = props.hideConnector ?? false;

    return (
        <div style={{ paddingTop: 12, paddingBottom: 12, position: 'relative' }}>
            {showHead && !hideConnector && (
                <div
                    style={{
                        position: 'absolute',
                        width: 2,
                        height: 12,
                        top: 0,
                        left: 'calc(50% - 1px)',
                        backgroundColor: 'rgba(89,89,89, 0.5)',
                    }}
                />
            )}
            <div
                style={{
                    transform: props.shouldShowMiniVersion ? 'scale(0.7)' : 'scale(1)',
                }}
            >
                <StatusNodeDot {...props} />
            </div>
            {showTail && !hideConnector && (
                <div
                    style={{
                        position: 'absolute',
                        width: 2,
                        height: 12,
                        bottom: 0,
                        left: 'calc(50% - 1px)',
                        backgroundColor: 'rgba(89,89,89, 0.5)',
                    }}
                />
            )}
        </div>
    );
};

export default StatusNode;
